module.exports = __webpack_public_path__ + "static/media/close-blue.68473979.svg";